import styled from 'styled-components'
import { useSelector } from 'react-redux'
import LoadingState from 'ui/components/LoadingState'
import AccountTransactionsTable from './AccountTransactionsTable'
import type { AccountTransactionsQueryOptions } from './types'
import { useMemo } from 'react'
import useAccountTransactions from './useAccountTransactions'
import { useSelectedManager } from '../../../util/hooks/useSelectedManager'

const Container = styled.div`
	padding: 16px;
`

const LoadingContainer = styled.div`
	margin-top: 64px;
`

const ITEMS_PER_PAGE = 15

function AccountTransactions() {
	const selectedFinanceCompanyUUID = useSelector(
		({ app }: any) => app?.selectedFinanceCompanyUUID,
	)

	const { selectedManager } = useSelectedManager()
	const selectedManagerUUID = selectedManager?.uuid

	const apiQueryParams = useMemo<AccountTransactionsQueryOptions>(
		() => ({
			managerUUID: selectedManagerUUID,
			companyUUID: selectedFinanceCompanyUUID,
			useEnableBanking: true,
		}),
		[selectedManagerUUID, selectedFinanceCompanyUUID],
	)

	const { transactions, loadingTransactions } =
		useAccountTransactions(apiQueryParams)

	const renderTable = () => {
		if (loadingTransactions) {
			return (
				<LoadingContainer>
					<LoadingState />
				</LoadingContainer>
			)
		}

		return (
			<AccountTransactionsTable
				transactions={transactions}
				totalItemCount={transactions.length}
				itemsPerPage={ITEMS_PER_PAGE}
			/>
		)
	}

	return <Container>{renderTable()}</Container>
}

export default AccountTransactions
